import { MarketRules } from '@/components/market/market-rules';
import type { MarketBases } from '@/types';

export default function Bases({ edition }: MarketBases) {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-4xl px-6 py-12">
        <MarketRules edition={edition} />
      </div>
    </div>
  );
}
